"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _Title = _interopRequireDefault(require("./Title"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _buttonControlSelector = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control-selector"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _DropdownList = _interopRequireDefault(require("@insided/shared/uikit/dropdown/DropdownList"));

var _DropdownBox = _interopRequireDefault(require("@insided/deprecated-control/EmailCampaigns/DropdownBox"));

var getButtons = function getButtons(props) {
  var saveAsDraftButton = {
    isPrincipal: true,
    title: 'Save as draft',
    onClick: function onClick(e) {
      var _props$onSaveAsDraft;

      return (_props$onSaveAsDraft = props.onSaveAsDraft) === null || _props$onSaveAsDraft === void 0 ? void 0 : _props$onSaveAsDraft.call(props, e);
    },
    variant: 'primary',
    class: 'qa-save',
    disabled: !props.hasUnsavedChanges
  };
  var saveChangesButton = {
    isPrincipal: true,
    title: props.hasUnsavedChanges ? 'Save changes' : 'All saved',
    onClick: function onClick(e) {
      var _props$onSaveChanges;

      return (_props$onSaveChanges = props.onSaveChanges) === null || _props$onSaveChanges === void 0 ? void 0 : _props$onSaveChanges.call(props, e);
    },
    variant: 'primary',
    class: 'qa-save',
    disabled: !props.hasUnsavedChanges
  };
  var publishButton = {
    isPrincipal: false,
    title: 'Publish now',
    onClick: function onClick(e) {
      return props.onPublish(e);
    },
    variant: 'primary',
    class: 'qa-publish',
    disabled: false
  };
  var deleteButton = {
    isPrincipal: false,
    title: 'Delete',
    onClick: function onClick(e) {
      var _props$onDelete;

      return (_props$onDelete = props.onDelete) === null || _props$onDelete === void 0 ? void 0 : _props$onDelete.call(props, e);
    },
    variant: 'danger',
    class: 'qa-delete',
    disabled: false
  };

  if (props.status === 'published') {
    return [saveChangesButton, deleteButton];
  }

  if (props.status === 'draft') {
    return [saveChangesButton, publishButton, deleteButton];
  }

  return [saveAsDraftButton, publishButton];
};

var Header = function Header(props) {
  var title = props.title,
      error = props.error,
      _onTitleChanged = props.onTitleChanged,
      csvDownloadUrl = props.csvDownloadUrl,
      csvDownloadText = props.csvDownloadText,
      eventId = props.eventId,
      status = props.status,
      isEventPassed = props.isEventPassed,
      onDuplicate = props.onDuplicate;

  var getMoreButtons = function getMoreButtons() {
    var downloadAttendeeLButton = {
      title: 'Download attendee list',
      href: csvDownloadUrl,
      class: 'download-attendee-list-button'
    };
    var cancelButton = {
      title: 'Cancel',
      href: '/event/overview'
    };
    var duplicateButton = {
      title: 'Duplicate',
      onClick: onDuplicate,
      class: '.qa-duplicate-button'
    };
    var buttons = [cancelButton];

    if (status !== 'new') {
      buttons.push(duplicateButton);
    }

    if (status === 'published') {
      buttons.unshift(downloadAttendeeLButton);
    }

    return buttons;
  };

  return (0, _preact.h)("div", {
    className: "control-header control-header--events"
  }, (0, _preact.h)("div", {
    className: "control-header__breadcrumb"
  }, (0, _preact.h)("a", {
    className: "control-header__breadcrumb-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)("/event/overview"),
    "data-track-type": "click",
    "data-element-name": "Back to Events link"
  }, "Back to Events")), (0, _preact.h)("div", {
    className: "control-header__title_container"
  }, (0, _preact.h)(_Title.default, {
    title: title,
    error: error,
    onTitleChanged: function onTitleChanged(title) {
      return _onTitleChanged(title);
    },
    eventId: eventId,
    status: status,
    isEventPassed: isEventPassed
  }), (0, _preact.h)("div", {
    className: "event-creator__action-buttons"
  }, (0, _preact.h)("div", {
    className: "event-creator__action-buttons__buttons"
  }, status === 'published' ? (0, _preact.h)("a", {
    className: "event-creator__button-download qa-download-csv",
    href: (0, _absoluteUrlRuntime.resolveUrl)(csvDownloadUrl),
    target: "_blank",
    rel: "noreferrer",
    "data-track-type": "click",
    "data-element-name": "CSV download link"
  }, csvDownloadText) : null, (0, _preact.h)(_Button.default, {
    variant: "secondary",
    className: "event-creator__button-cancel qa-cancel-button",
    onClick: function onClick() {
      window.location.assign('/event/overview');
    },
    "data-track-type": "click",
    "data-element-name": "Cancel button"
  }, "Cancel"), status !== 'new' ? (0, _preact.h)(_Button.default, {
    variant: "secondary",
    className: "event-creator__button-duplicate qa-duplicate-button",
    onClick: onDuplicate
  }, "Duplicate") : null), (0, _preact.h)(_DropdownBox.default, {
    title: (0, _preact.h)("div", {
      className: "event-creator__action-buttons__more-btn"
    }, (0, _preact.h)(_assets.default, {
      icon: "moreHoriz"
    })),
    disabled: false,
    className: "event-creator__action-buttons__more-dropdown"
  }, (0, _preact.h)(_DropdownList.default, {
    items: getMoreButtons(),
    align: "top",
    hasSearch: false
  })), (0, _preact.h)(_buttonControlSelector.default, {
    key: "publish-event",
    size: "small",
    variant: "brand",
    disabled: false,
    items: getButtons(props),
    triggerButtonCustomClassName: "qa-selector-open-button"
  }))));
};

var _default = Header;
exports.default = _default;